// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_borderInner__0pA-s {
    position: absolute;
    height: 100%;
    width: 100%
}
@keyframes style_spin__Bmya6 {
    to {
        transform: rotate(360deg)
    }
}
.style_borderInner__0pA-s {
    animation: style_spin__Bmya6 1s linear infinite;
    border-radius: 9999px;
    border-width: 3px;
    border-color: rgb(255 255 255 / 0.9);
    clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%)
}
.style_borderOuter__i8Wqv {
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 9999px;
    border-width: 3px;
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/components/PageLoader/style.module.css"],"names":[],"mappings":"AACI;IAAA,kBAAoF;IAApF,YAAoF;IAApF;AAAoF;AAApF;IAAA;QAAA;IAAoF;AAAA;AAApF;IAAA,+CAAoF;IAApF,qBAAoF;IAApF,iBAAoF;IAApF,oCAAoF;IACpF;AADoF;AAIpF;IAAA,kBAAuE;IAAvE,YAAuE;IAAvE,WAAuE;IAAvE,qBAAuE;IAAvE,iBAAuE;IAAvE,sBAAuE;IAAvE;AAAuE","sourcesContent":[".borderInner {\n    @apply animate-spin absolute rounded-full w-full h-full border-[3px] border-white/90;\n    clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%);\n}\n.borderOuter {\n    @apply absolute w-full h-full rounded-full border-[3px] border-gray-400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borderInner": `style_borderInner__0pA-s`,
	"spin": `style_spin__Bmya6`,
	"borderOuter": `style_borderOuter__i8Wqv`
};
export default ___CSS_LOADER_EXPORT___;
